
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter,Redirect } from 'react-router-dom';
import {logout} from '../actions/AppActions';
import { connect } from 'react-redux';
import { getLanguageTexts, getSelectedLanguage } from '../language';

// users
import user4 from '../assets/images/default.png';

class ProfileMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect:false,
            path:'/'
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }

    logout(){
        localStorage.removeItem('token');
        // this.setState({redirect:true,path:'/'});
        this.props.logout();
    }


    render() {
        const t = getLanguageTexts(getSelectedLanguage());

        return (
            <React.Fragment>
                {this.state.redirect == true && <Redirect to={this.state.path} />}
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block" >
                    <DropdownToggle className="btn header-item waves-effect external-camera-profile-toggle" id="page-header-user-dropdown" tag="button">
                        <span className="external-camera-profile-meta">
                            <strong>{this.props.user?.name || t.candidate}</strong>
                            <small>{this.props.user?.email || 'OnTest'}</small>
                        </span>
                        <img className="rounded-circle header-profile-user" src={user4} height="50" alt="Header Avatar" />
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem tag="a" onClick={this.logout.bind(this)}><i className="mdi mdi-logout font-size-17 align-middle mr-1"></i>{t.logout}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}
const mapsStateToProps = (state) => (
    {
        user: state.AppReducer.user || {}
    }
);

export default withRouter(connect(mapsStateToProps, { logout })(ProfileMenu));


